import { useQuery } from "react-query";
import { API_KEY_GET_MANAGEABLE_LIST_USER_SEARCH } from "../constants";
import { getSearchUser } from "../api";

export const useGetSearchUser = (params) => {
  return useQuery([API_KEY_GET_MANAGEABLE_LIST_USER_SEARCH, params], () =>
    getSearchUser(params)
  );
};
